import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
`;

export const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  background-color: #e1e3f4;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
`;

export const LoadingContent = styled.div`
  padding: 20px 40px;
  border-radius: 8px;
  text-align: center;
  justify-items: center;
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
`;

export const LoadingText = styled.div`
  color: #000;
  font-size: 17px;
  font-weight: 400;
  animation: ${pulse} 1s ease-in-out infinite;
  text-align: center;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 60%;
  border-top: 4px solid #3498db;
  width: 50px;
  height: 50px;
  margin: 0 auto 15px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
